<template>
  <div class="view-trip">
    <b-button block @click="openModal" variant="primary">{{ buttonTitle }}</b-button>

    <b-modal
      ref="createTripModal"
      :title="buttonTitle"
      :no-close-on-backdrop="true"
      @ok="bookTrip"
      @hidden="resetModal"
      scrollable
    >
      <div v-if="!modalLoaded" :style="{'width': '50px','margin':'0 auto'}">
        <b-spinner
          label="Spinning"
          :style="{
              'width': '50px',
              'height': '50px'
              }"
        ></b-spinner>
      </div>
      <div v-else>
        <b-row>
          <b-col cols="12" md="6" v-if="type === 'trip'">
            <b-form-group
              label="Rider name"
              :invalid-feedback="modal.bookingErrors.passengerName"
              :state="(typeof modal.bookingErrors.passengerName !== 'undefined') ? false : null"
            >
              <b-form-input
                v-model="modal.booking.passengerName"
                type="text"
                required
                placeholder="Full name of the rider you are booking the trip for."
                :state="(typeof modal.bookingErrors.passengerName !== 'undefined') ? false : null"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="12" md="6" v-if="type === 'trip'">
            <b-form-group
              label="Rider number"
              :invalid-feedback="modal.bookingErrors.passengerNumber"
              :state="(typeof modal.bookingErrors.passengerNumber !== 'undefined') ? false : null"
            >
              <b-form-input
                v-model="modal.booking.passengerNumber"
                type="number"
                required
                placeholder="Contact number of the rider."
                :state="(typeof modal.bookingErrors.passengerNumber !== 'undefined') ? false : null"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group
              label="Notes"
              :invalid-feedback="modal.bookingErrors.notes"
              :state="(typeof modal.bookingErrors.notes !== 'undefined') ? false : null"
            >
              <b-form-textarea
                id="textarea"
                v-model="modal.booking.notes"
                placeholder="Enter trip notes..."
                rows="3"
                max-rows="6"
                :state="(typeof modal.bookingErrors.notes !== 'undefined') ? false : null"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>
        <hr v-if="type === 'trip'" />
        <b-row v-if="type === 'trip'">
          <b-col cols="12" md="7">
            <b-form-group label="Facilities">
              <facilities v-model="modal.facilitiesList" :facilities="modal.facilities" />
            </b-form-group>
          </b-col>
          <b-col cols="12" md="5">
            <b-form-group label="Passengers">
              <b-form-radio
                v-model="modal.accompanyingRider"
                name="passengers-select"
                value="0"
                :style="{'margin': '4px 0', 'font-weight': 'normal'}"
              >18+ female only</b-form-radio>
              <b-form-radio
                v-model="modal.accompanyingRider"
                name="passengers-select"
                value="1"
                :style="{'margin': '4px 0', 'font-weight': 'normal'}"
              >18+ male only</b-form-radio>
              <b-form-radio
                v-model="modal.accompanyingRider"
                name="passengers-select"
                value="2"
                :style="{'margin': '4px 0', 'font-weight': 'normal'}"
              >18+ female & male</b-form-radio>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group label="Car Size">
              <selectCarSize v-model="modal.carSize" />
            </b-form-group>
          </b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col cols="12" md="6">
            <b-form-group
              label="Pick up location"
              :invalid-feedback="modal.bookingErrors.pickUpAddress"
              :state="(typeof modal.bookingErrors.pickUpAddress !== 'undefined') ? false : null"
            >
              <googleSearchAddress
                @addressCallback="addressCallbackFrom"
                placeholder="Enter pick up address"
                :geometry="true"
                :state="(typeof modal.bookingErrors.pickUpAddress !== 'undefined') ? false : null"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" md="6">
            <b-form-group
              label="Drop off location"
              :invalid-feedback="modal.bookingErrors.dropOffAddress"
              :state="(typeof modal.bookingErrors.dropOffAddress !== 'undefined') ? false : null"
            >
              <googleSearchAddress
                @addressCallback="addressCallbackTo"
                placeholder="Enter drop off address"
                :geometry="true"
                :state="(typeof modal.bookingErrors.dropOffAddress !== 'undefined') ? false : null"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-form-group label="Booking Type" v-if="modal.haveLocations">
          <b-form-radio-group>
            <b-row>
              <b-col cols="12" md="6">
                <b-button
                  block
                  :variant="(bookingType === 'advance') ? 'primary' : 'secondary'"
                  @click="toggleBookingType('advance')"
                >Advance Booking</b-button>
              </b-col>
              <b-col cols="12" md="6">
                <b-button
                  block
                  :variant="(bookingType === 'instant') ? 'primary' : 'secondary'"
                  @click="toggleBookingType('instant')"
                >Instant Booking</b-button>
              </b-col>
            </b-row>
          </b-form-radio-group>
        </b-form-group>

        <div v-if="bookingType === 'advance'">
          <b-row>
            <b-col cols="12">
              <b-form-group
                label="Preferred Driver"
                :invalid-feedback="modal.bookingErrors.preferredDriver"
                :state="(typeof modal.bookingErrors.preferredDriver !== 'undefined') ? false : null"
              >
                <v-select
                  inputId="_id"
                  placeholder="Choose preferred driver"
                  @input="selectDriver"
                  :value="modal.preferredDriver"
                  :options="modal.preferredDrivers"
                  :state="(typeof modal.bookingErrors.preferredDriver !== 'undefined') ? false : null"
                >
                  <template v-slot:spinner="option">
                    <b-spinner
                      v-show="modal.preferredDriversLoading"
                      label="Spinning"
                      :style="{
                      'width': '10px',
                      'height': '10px'
                      }"
                    ></b-spinner>
                  </template>
                  <template v-slot:selected-option="option">
                    <font-awesome-icon icon="user-circle" v-if="true" />
                    <span
                      class="prefered-driver-profile-image"
                      v-else
                      :style="{'background-image': `url(${option.driverphotoUrl})`}"
                    ></span>
                    {{ option.firstName }} {{ option.lastName }}
                    <span
                      v-if="option.location"
                    >- {{ option.location }}</span>
                    <span
                      v-for="item in option.facilities"
                      :key="item"
                      :style="{'display': 'inline-block', 'margin-left': '5px'}"
                    >
                      <b-badge>{{ item }}</b-badge>
                    </span>
                  </template>
                  <template v-slot:option="option">
                    <font-awesome-icon icon="user-circle" v-if="true" />
                    <span
                      class="prefered-driver-profile-image"
                      v-else
                      :style="{'background-image': `url(${option.driverphotoUrl})`}"
                    ></span>
                    {{ option.firstName }} {{ option.lastName }}
                    <span
                      v-if="option.location"
                    >- {{ option.location }}</span>
                    <span
                      v-for="item in option.facilities"
                      :key="item"
                      :style="{'display': 'inline-block', 'margin-left': '5px'}"
                    >
                      <b-badge>{{ item }}</b-badge>
                    </span>
                  </template>
                </v-select>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group
                label="Scheduled pickup date"
                :invalid-feedback="modal.bookingErrors.schedule"
                :state="(typeof modal.bookingErrors.schedule !== 'undefined') ? false : null"
                class="create-trip-date-time"
              >
                <VueCtkDateTimePicker
                  :minDate="minDate"
                  :maxDate="maxDate"
                  :error="(typeof modal.bookingErrors.schedule === 'undefined') ? null : true"
                  v-model="modal.booking.schedule"
                  format="YYYY-MM-DDTHH:mm:ssz"
                ></VueCtkDateTimePicker>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
        <div v-if="bookingType === 'instant'">
          <div
            v-if="modal.seachNearbyDrivers === true && modal.foundNearbyDrivers === null"
            :style="{'text-align': 'center'}"
          >
            <b-spinner
              variant="primary"
              label="Spinning"
              x
              :style="{
              'width': '25px',
              'height': '25px'
              }"
            ></b-spinner>
          </div>
          <div
            v-else-if="modal.seachNearbyDrivers === false && modal.foundNearbyDrivers === false"
            :style="{'text-align': 'center'}"
          >
            <h5>Our apologies.</h5>There seems to be
            <u>0 nearby drivers</u> close to your pickup location.
            <div :style="{'width':'50px', 'margin': '10px auto'}">
              <b-button pill variant="outline-secondary" @click="doNearbyDriver">
                <font-awesome-icon icon="redo" />
              </b-button>
            </div>
          </div>
          <div
            v-else-if="modal.seachNearbyDrivers === false && modal.foundNearbyDrivers === true"
            :style="{'text-align': 'center'}"
          >
            <h5>Found {{modal.numberOfDrivers}} driver{{(modal.numberOfDrivers > 1) ? 's': ''}} nearby</h5>
          </div>
          <b-alert
            variant="danger"
            :show="(modal.requestErrorMsg === null) ? false : true"
            dismissible
          >{{ modal.requestErrorMsg }}</b-alert>
        </div>
      </div>
      <template v-slot:modal-footer>
        <div :style="{'width': '100%'}">
          <div :style="{'float': 'left'}">
            <b-alert
              variant="danger"
              :show="(modal.requestErrorMsg === null) ? false : true"
              dismissible
            >{{ modal.requestErrorMsg }}</b-alert>
            <div v-if="modal.gettingFareEstimate" :style="{'text-align': 'center'}">
              <b-spinner
                variant="primary"
                label="Spinning"
                :style="{
              'width': '25px',
              'height': '25px'
              }"
              ></b-spinner>
            </div>
            <div v-if="modal.fareEstimate !== null">
              <h3 :style="{'margin': '0px'}">
                ${{ modal.fareEstimate.fareEstimate / 100 }}
                <span
                  :style="{'font-size': '12px'}"
                >(Fare Estimate)</span>
                <b-button
                  pill
                  variant="outline-secondary"
                  @click="requestBooking"
                  :style="{'margin-left': '20px'}"
                >
                  <font-awesome-icon icon="redo" />
                </b-button>
              </h3>
            </div>
          </div>
          <div :style="{'float': 'right'}">
            <b-button size="sm" variant="secondary" @click="cancel()">Cancel</b-button>
            <b-button
              variant="primary"
              @click="requestBooking"
              v-if="modal.canRequestTrip"
            >Request Estimate</b-button>
            <b-button
              size="sm"
              variant="primary"
              v-if="!modal.canNotBookTrip"
              @click="bookTrip()"
              :disabled="bookingTrip"
            >
              Book Trip
              <b-spinner
                v-if="bookingTrip"
                style="width: 15px;height: 15px;display: inline-block;margin-left: 10px;"
                variant="primary"
                label="Spinning"
              ></b-spinner>
            </b-button>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import moment from "moment";
import shebahApi from "@/services/shebah/index";
import { googleSearchAddress } from "@/components/google/index";
import general from "@/utilities/general/index";
import facilities from "@/components/facilities";
import selectCarSize from "@/components/selectCarSize";

export default {
  name: "createBooking",
  components: {
    googleSearchAddress,
    facilities,
    selectCarSize
  },
  props: {
    type: String,
    buttonTitle: String,
    createdCallback: Function
  },
  computed: {
    authUser() {
      return this.$store.getters["authUser/user"];
    },
    minDate() {
      return moment().format();
    },
    maxDate() {
      return moment().add(14, 'days').endOf("day").format();
    }
  },
  data() {
    return {
      modal: {},
      modalLoaded: false,
      bookingType: null,
      bookingTrip: false,
      default: {
        booking: {},
        haveLocations: false,
        pickUpAddress: null,
        dropOffAddress: null,
        fareEstimate: null,
        canNotBookTrip: true,
        canRequestTrip: false,
        seachNearbyDrivers: false,
        foundNearbyDrivers: null,
        nearbyDrivers: [],
        numberOfDrivers: 0,
        preferredDriver: null,
        preferredDriversLoading: false,
        preferredDrivers: [],
        facilitiesLoading: false,
        facilities: [],
        selectedFacilities: {},
        cards: [],
        bookingErrors: {},
        gettingFareEstimate: false,
        requestErrorMsg: null,
        facilitiesList: [],
        carSize: null,
        accompanyingRider: null
      }
    };
  },
  watch: {
    "modal.accompanyingRider": async function(newValue) {
      this.resetOnChange();
    },
    "modal.carSize": async function(newValue) {
      this.resetOnChange();
    },
    "modal.facilitiesList": async function(newValue) {
      this.resetOnChange();
    },
    async bookingType() {
      if (this.bookingType === "instant") {
        this.doInstantBooking();
      } else if (this.bookingType === "advance") {
        this.doAdvanceBooking();
      } else {
        this.modal.canRequestTrip = false;
        this.modal.canNotBookTrip = true;
        this.modal.requestErrorMsg = null;
      }
    }
  },
  created() {
    this.modal = JSON.parse(JSON.stringify(this.default));
  },
  methods: {
    async doNearbyDriver() {
      this.seachNearbyDrivers = true;
      this.modal.foundNearbyDrivers = null;
      await this.doInstantBooking();
    },
    async doInstantBooking() {
      this.modal.fareEstimate = null;
      this.modal.canRequestTrip = false;
      this.modal.canNotBookTrip = true;
      this.modal.seachNearbyDrivers = true;
      this.modal.requestErrorMsg = null;

      // Get boundry box to search for nearby drivers
      let bounding = this.getBoundingBox(this.modal.pickUpAddress.location);

      // Get nearby driver in boundry box
      this.modal.nearbyDrivers = await shebahApi.api.bookings.nearbyDrivers({
        bbox: { sw: bounding.sw.reverse(), ne: bounding.ne.reverse() }
      });

      this.modal.seachNearbyDrivers = false;

      // If there are nearby drivers the user can do a instant booking
      if (this.modal.nearbyDrivers.data.length > 0) {
        this.modal.numberOfDrivers = this.modal.nearbyDrivers.data.length;
        this.modal.foundNearbyDrivers = true;
        this.modal.canRequestTrip = true;
      } else {
        this.modal.foundNearbyDrivers = false;
      }
    },
    async doAdvanceBooking() {
      this.seachNearbyDrivers = true;
      this.modal.foundNearbyDrivers = null;
      this.modal.fareEstimate = null;
      this.modal.requestErrorMsg = null;
      this.modal.canRequestTrip = true;
      this.modal.canNotBookTrip = true;
    },
    resetOnChange() {
      if (this.modal.haveLocations) {
        this.modal.fareEstimate = null;
        this.modal.requestErrorMsg = null;
        this.modal.canRequestTrip = true;
        this.modal.canNotBookTrip = true;
      }
    },
    cancel() {
      this.$refs["createTripModal"].hide();
    },
    toggleBookingType(type) {
      this.bookingType = type;
    },
    async openModal() {
      this.modalLoaded = false;
      this.$refs.createTripModal.show();
      // Force only advance booking
      this.bookingType = "";
      this.modal.canRequestTrip = true;
      await this.mutateDrivers();
      await this.mutateFacility();

      this.modalLoaded = true;
    },
    addressCallbackFrom(address) {
      this.modal.fareEstimate = null;
      this.bookingType = null;
      this.modal.pickUpAddress = address;
      this.modal.pickUpAddress.location.reverse();
      if (this.modal.dropOffAddress !== null) {
        this.modal.haveLocations = true;
      }
    },
    addressCallbackTo(address) {
      this.modal.fareEstimate = null;
      this.bookingType = null;
      this.modal.dropOffAddress = address;
      this.modal.dropOffAddress.location.reverse();
      if (this.modal.pickUpAddress !== null) {
        this.modal.haveLocations = true;
      }
    },
    resetModal() {
      this.bookingTrip = false;
      this.bookingType = null;
      this.modal = JSON.parse(JSON.stringify(this.default));
    },
    async requestBooking() {
      try {
        this.modal.fareEstimate = null;
        let validate = general.validation();

        let validationRules = {};

        if (this.type === "trip") {
          switch (this.bookingType) {
            case "instant":
              validationRules = {
                passengerName: {
                  rules: "required",
                  field_name: "Rider name"
                },
                passengerNumber: {
                  rules: "required",
                  field_name: "Rider name"
                }
              };
              break;
            case "advance":
              validationRules = {
                passengerName: {
                  rules: "required",
                  field_name: "Rider name"
                },
                passengerNumber: {
                  rules: "required",
                  field_name: "Rider name"
                },
                schedule: {
                  rules: "required",
                  field_name: "Date and Time"
                }
              };
              // if (this.modal.preferredDriver === null) {
              //   validate.setError("preferredDriver", "Preferred driver");
              // }
              break;
          }
        } else if (this.type === "drop") {
          // Set trip as delivery
          this.modal.booking.isDelivery = true;

          switch (this.bookingType) {
            case "instant":
              validationRules = {
                notes: {
                  rules: "required",
                  field_name: "Notes"
                }
              };
              break;
            case "advance":
              validationRules = {
                notes: {
                  rules: "required",
                  field_name: "Notes"
                },
                schedule: {
                  rules: "required",
                  field_name: "Date and Time"
                }
              };
              break;
          }
        }

        validate.setValidFields(validationRules);

        if (this.modal.pickUpAddress === null) {
          validate.setError("pickUpAddress", "Pick up address");
        }

        if (this.modal.dropOffAddress === null) {
          validate.setError("dropOffAddress", "Drop off address");
        }

        if (validate.isValid(this.modal.booking)) {
          this.modal.bookingErrors = {};
          this.modal.bookingDetails = {};
          if (typeof this.modal.bookingDetails.schedule !== "undefined") {
            this.modal.bookingDetails.isAdvancedBooking = true;
          }

          this.modal.bookingDetails.start_location = {
            geo: this.modal.pickUpAddress.location
          };

          this.modal.bookingDetails.end_location = {
            geo: this.modal.dropOffAddress.location
          };

          if (this.modal.carSize !== "") {
            this.modal.bookingDetails.carSize = Number(this.modal.carSize);
          }

          if (this.type === "drop") {
            this.modal.bookingDetails.isDelivery = true;
          }

          if (this.modal.accompanyingRider !== null) {
            this.modal.bookingDetails.accompanyingRider = Number(
              this.modal.accompanyingRider
            );
          }

          if (this.modal.preferredDriver !== null) {
            this.modal.bookingDetails.preferredDriver = this.modal.preferredDriver._id;
          }

          this.modal.bookingDetails.facilitiesList = this.facilityInterface(
            this.modal.facilities,
            this.modal.facilitiesList
          );

          this.modal.gettingFareEstimate = true;
          console.log(shebahApi.api.bookings);
          let fareEstimate = await shebahApi.api.bookings.fareEstimate(
            this.modal.bookingDetails
          );
          this.modal.cards = await shebahApi.api.billing.paymentMethods();
          this.modal.fareEstimate = fareEstimate;
          this.modal.gettingFareEstimate = false;

          this.modal.canNotBookTrip = false;
          this.modal.canRequestTrip = false;
        } else {
          this.modal.bookingErrors = validate.errors;
        }
      } catch (e) {
        this.modal.canRequestTrip = true;
        this.modal.gettingFareEstimate = false;
        if (typeof e.response !== "undefined") {
          this.modal.requestErrorMsg = e.response.data.error.msg;
        } else {
          console.error(e);
        }
      }
    },
    async bookTrip() {
      let booking = {
        card_id: this.modal.cards[0].id,
        start_location: {
          geo: this.modal.pickUpAddress.location,
          address: this.modal.pickUpAddress.address,
          placeId: this.modal.pickUpAddress.placeId
        },
        end_location: {
          geo: this.modal.dropOffAddress.location,
          address: this.modal.dropOffAddress.address,
          placeId: this.modal.dropOffAddress.placeId
        },
        facilities: this.modal.bookingDetails.facilities,
        facilitiesList: this.facilityInterface(
          this.modal.facilities,
          this.modal.facilitiesList
        ),
        fareEstimate: this.modal.fareEstimate.fareEstimate,
        accompanyingRider: this.modal.bookingDetails.accompanyingRider,
        carSize:
          typeof this.modal.bookingDetails.carSize === "undefined"
            ? "0"
            : this.modal.bookingDetails.carSize
      };

      if (this.modal.preferredDriver !== null) {
        booking.preferredDriverId = this.modal.preferredDriver._id;
      }

      if (this.modal.preferredDriver !== null) {
        booking.preferredDriverId = this.modal.preferredDriver._id;
      }

      if (typeof this.modal.booking.schedule !== "undefined") {
        booking.schedule = this.modal.booking.schedule;
      }

      if (typeof this.modal.booking.schedule !== "undefined") {
        booking.is_advanced = true;
      }

      if (this.type === "drop") {
        booking.isDelivery = true;
      }

      booking.metadata = {};

      if (this.modal.booking.passengerName !== "") {
        booking.metadata.passengerName = this.modal.booking.passengerName;
      }

      if (this.modal.booking.passengerNumber !== "") {
        booking.metadata.passengerNumber = this.modal.booking.passengerNumber;
      }

      if (this.modal.booking.notes !== "") {
        booking.notes = this.modal.booking.notes;
      }
      this.bookingTrip = true;
      await shebahApi.api.bookings.createBooking(booking);
      this.$refs["createTripModal"].hide();
      this.createdCallback();
      this.bookingTrip = false;
    },
    getBoundingBox(centerPoint, distance = 30) {
      var MIN_LAT,
        MAX_LAT,
        MIN_LON,
        MAX_LON,
        R,
        radDist,
        degLat,
        degLon,
        radLat,
        radLon,
        minLat,
        maxLat,
        minLon,
        maxLon,
        deltaLon;
      if (distance < 0) {
        return "Illegal arguments";
      }
      // helper functions (degrees<–>radians)
      Number.prototype.degToRad = function() {
        return this * (Math.PI / 180);
      };
      Number.prototype.radToDeg = function() {
        return (180 * this) / Math.PI;
      };
      // coordinate limits
      MIN_LAT = (-90).degToRad();
      MAX_LAT = (90).degToRad();
      MIN_LON = (-180).degToRad();
      MAX_LON = (180).degToRad();
      // Earth's radius (km)
      R = 6378.1;
      // angular distance in radians on a great circle
      radDist = distance / R;
      // center point coordinates (deg)
      degLat = centerPoint[1];
      degLon = centerPoint[0];
      // center point coordinates (rad)
      radLat = degLat.degToRad();
      radLon = degLon.degToRad();
      // minimum and maximum latitudes for given distance
      minLat = radLat - radDist;
      maxLat = radLat + radDist;
      // minimum and maximum longitudes for given distance
      minLon = void 0;
      maxLon = void 0;
      // define deltaLon to help determine min and max longitudes
      deltaLon = Math.asin(Math.sin(radDist) / Math.cos(radLat));
      if (minLat > MIN_LAT && maxLat < MAX_LAT) {
        minLon = radLon - deltaLon;
        maxLon = radLon + deltaLon;
        if (minLon < MIN_LON) {
          minLon = minLon + 2 * Math.PI;
        }
        if (maxLon > MAX_LON) {
          maxLon = maxLon - 2 * Math.PI;
        }
      }
      // a pole is within the given distance
      else {
        minLat = Math.max(minLat, MIN_LAT);
        maxLat = Math.min(maxLat, MAX_LAT);
        minLon = MIN_LON;
        maxLon = MAX_LON;
      }

      return {
        ne: [maxLat.radToDeg(), maxLon.radToDeg()],
        sw: [minLat.radToDeg(), minLon.radToDeg()]
      };
    },
    async mutateDrivers() {
      this.modal.preferredDriversLoading = true;
      let preferredDrivers = await shebahApi.api.root.preferredDriver();
      this.modal.preferredDriversLoading = false;

      for (let driver of preferredDrivers) {
        driver.label = `${driver.firstName} ${driver.lastName}`;
      }
      this.modal.preferredDrivers = preferredDrivers;
    },
    selectDriver(val) {
      this.modal.preferredDriver = val;
    },
    async mutateFacility() {
      this.modal.facilitiesLoading = true;
      let facilities = await shebahApi.api.root.facilities();
      this.modal.facilitiesLoading = false;

      for (let facility of facilities) {
        facility.label = `${facility.title} $${(facility.price / 100).toFixed(
          2
        )}`;
      }
      this.modal.facilities = facilities;
    },
    selectFacility(val) {
      this.modal.selectedFacilities = val;
    },
    facilityInterface(facilities, selectedFacilities) {
      let bookingFacilities = [];

      for (let facility of selectedFacilities) {
        let foundFacility = facilities.find(f => f._id == facility._id);

        bookingFacilities.push({
          _id: foundFacility._id,
          name: foundFacility.title,
          seats: facility.qty
        });
      }

      return bookingFacilities;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.prefered-driver-profile-image {
  height: 50px;
  width: 50px;
  border-radius: 50%;
  overflow: hidden;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  margin-right: 20px;
  display: inline-block;
  align-items: center;
}
</style>
